import _get from 'lodash/get';
import React from 'react';
import FlipMove from 'react-flip-move';
import avatarImage from 'assets/images/icon-empty-profile-img.png';
import UserListItem from 'components/UI/UserListItem/UserListItem';

const accountUsersList = (props) => {
  const sortedUsers = props.allUsers
    ? props.allUsers.sort((a, b) => {
        if (a.isPostingUser === true) {
          return -1;
        }
        if (a.FirstName.toLowerCase() < b.FirstName.toLowerCase()) {
          return -1;
        }
        if (a.FirstName.toLowerCase() > b.FirstName.toLowerCase()) {
          return 1;
        }
        if (a.FirstName.toLowerCase() === b.FirstName.toLowerCase()) {
          return 0;
        }
        return 1;
      })
    : [];

  let usersList = [];
  if (sortedUsers.length > 0) {
    usersList = sortedUsers.map((user) => (
      <div key={user.UserId}>
        <UserListItem
          userId={user.UserId}
          color={user.Color}
          thumbURL={_get(user, 'ImageURL', _get(user, 'ThumbURL', avatarImage))}
          name={user.FirstName}
          selected={user.isPostingUser}
          clicked={() => props.updatePostingAs(user.UserId)}
        />
      </div>
    ));
  }

  return (
    <div>
      <FlipMove duration={500}>{usersList}</FlipMove>
    </div>
  );
};

export default accountUsersList;
